export default function LockCombination() {
  return (
    <div
      className="ion-icon-lock-combination"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M384,176.905V128C384,57.308,326.692,0,256,0S128,57.308,128,128v48.906C88.725,212.062,64,263.141,64,320
		c0,106.039,85.962,192,192,192c106.039,0,192-85.961,192-192C448,263.141,423.275,212.062,384,176.905z M160,128
		c0-52.935,43.065-96,96-96s96,43.065,96,96v25.692C323.759,137.355,290.973,128,256,128s-67.759,9.355-96,25.693V128z M256,480
		c-88.366,0-160-71.634-160-160s71.634-160,160-160s160,71.634,160,160S344.366,480,256,480z"/>
	<path d="M256,176c-79.529,0-144,64.472-144,144s64.471,144,144,144s144-64.472,144-144S335.529,176,256,176z M378.533,353.487
		l-24.12-7.896l-3.926,12.19l24.161,7.912c-3.661,9.776-8.462,18.965-14.252,27.409l-10.56-7.737l-3.74,5.184l10.555,7.734
		c-6.129,8.047-13.189,15.324-21.028,21.682l-14.982-20.787l-10.284,7.532l14.976,20.776c-8.479,5.556-17.657,10.12-27.398,13.532
		l-3.96-12.294l-6.049,1.982l4.924,12.262C283.335,445.77,273,447.497,264,448v-12.659V429h-16v6.341V448
		c-11-0.506-19.705-2.244-29.243-5.065l3.948-11.206l-6.25-2.106l-3.539,11.224c-9.557-3.393-18.531-7.895-26.864-13.359
		l14.997-20.774l-10.27-7.534l-14.977,20.787c-7.809-6.333-14.841-13.575-20.953-21.583l9.556-6.998l-3.971-5.507l-9.562,7
		c-5.718-8.381-10.469-17.497-14.093-27.186l24.162-7.914l-3.926-12.188l-24.121,7.897c-2.49-9.431-3.954-18.488-4.258-29.487H134
		v-6.805l-5.993-0.002c0.223-10.606,0.672-20.88,3.266-30.682l24.921,7.9l4.347-12.188l-23.966-7.914
		c3.585-9.57,8.36-18.583,13.985-26.879l10.339,7.533l3.759-5.184l-10.292-7.545c6.221-8.253,13.424-15.707,21.434-22.197
		l14.984,20.787l10.284-7.536l-14.975-20.774c8.405-5.514,17.512-10.05,27.16-13.449l3.955,12.247l6.044-1.98l-4.62-12.231
		C228.21,194.258,237,192.508,248,192v12.66V211h16v-6.34V192c9,0.498,19.159,2.198,28.585,4.951l-4.761,13.28l6.182,2.106
		l4.174-13.312c9.696,3.408,18.778,7.957,27.208,13.491l-15.002,20.775l10.267,7.535l14.975-20.787
		c7.935,6.432,15.069,13.812,21.255,21.977l-11.299,8.268l3.975,5.512l11.276-8.26c5.595,8.271,10.247,17.243,13.816,26.775
		l-24.165,7.914l3.928,12.188l24.12-7.9c2.586,9.802,5.251,20.075,5.47,30.683L376,317.192V324h6.789
		C382.486,334.999,381.02,344.057,378.533,353.487z"/>
	<circle cx="256" cy="320" r="81"/>
</g>
</svg>
`,
      }}
    />
  )
}
